const insightSection = document.querySelector("#insights-and-updates");
if (insightSection) {
    console.log('insight section exists');
  let insightSliderPromise = new Promise(function (sliderResolve) {
    const iSlider = tns({
      container: insightSection.querySelector(".slider"),
      //items: 1,
      // center: true,
      autoplay: false,
      controls: true,
      nav: false,
      //navContainer: insightSlider.querySelector('.team-slider-nav'),
      loop: false,
      autoplayButtonOutput: false,
      controlsContainer: insightSection.querySelector(".slider-controls"),
      speed: 400,
      gutter: 24,
      fixedWidth: 283,
      // items: 1,
      fixedHeight: true,
      //fixedWidth: 283,
      disable: false,
    //   responsive: {
    //     768: {
    //       disable: true,
    //     },
    //   },
    });
    sliderResolve(iSlider.getInfo().container);

    insightSliderPromise.then(function (sliderContainer) {
      // .. code after the slider has been built up
      console.log("insights slider is ready!");
      const slider = insightSection.querySelector(".slider");
      //   slider.classList.remove("space-x-6");
    });
  });
}
